import SearchSelect from "./SearchSelect"

/**
 * Picking a client, by typing.
 *
 * The behaviour is SearchSelect's; what is here is the vocabulary. A client is
 * matched on its name and on its tenant id, because people who administer
 * several tenants know them by the id as readily as by the name, and it is what
 * is printed on everything else.
 *
 * The same picker appears on Projects, Tasks, Chat, Billing, Log time and five
 * dialogs. Ten selects nobody can type into is a consistent app; nine of those
 * plus one that works is a worse one, because what the control does would then
 * depend on which screen you are looking at.
 */
export default function ClientSelect({ clients = [], emptyLabel = "Choose a client…", ...rest }) {
  return (
    <SearchSelect
      options={clients}
      label="Client"
      emptyLabel={emptyLabel}
      getSearchText={(client) => `${client.name ?? ""} ${client.id ?? ""}`}
      noOptionsText="No client matches"
      {...rest}
    />
  )
}
